export default __webpack_public_path__ + "static/media/aura.a7bdab15.png";